import { render, staticRenderFns } from "./NewHomeAccountStatus.vue?vue&type=template&id=701d6e16&scoped=true"
import script from "./NewHomeAccountStatus.vue?vue&type=script&lang=ts"
export * from "./NewHomeAccountStatus.vue?vue&type=script&lang=ts"
import style0 from "./NewHomeAccountStatus.vue?vue&type=style&index=0&id=701d6e16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d6e16",
  null
  
)

export default component.exports